export const ALT = 'Alt image title';
export const HOST = 'https://www.pinterest.com/pin/create/button/';
export const GUID = 'Dz6gFxmej__M';
export const PINTEREST_SRC = '//assets.pinterest.com/js/pinit.js';
